/**
 * 人工中文文案（只放中文）
 * en.js 仅收录译员已翻译字段；未翻译字段由小牛页面翻译
 */
export default {
  siteTitle: '中国电力工程技术标准数据管理平台',
  nav: {
    home: '首页',
    standardSearch: '标准检索',
    csepdi: '中南电力设计院',
    snerdi: '国核电力规划设计研究院',
    gxedi: '中能建广西电力设计研究院',
    digitization: '数字化标准比对',
    benchmarking: '中外标准对标展示',
    benchmarkSurvey: '勘察设计对标',
    benchmarkInstall: '安装施工对标',
    standardTranslation: '中国标准英文出版物',
    technicalRegulations: '国别技术法规',
    languageService: '标准化语言服务',
    call: '国际招标信息',
    informationNavigation: '国际信息导航',
    standardList: '国际工程标准清单',
    platformAssistant: '平台助手',
    teamwork: '协同工作',
    ceppea: 'CEPPEA标准',
    tipTitle: '提示',
    vipTips: '温馨提示：该内容为本站VIP会员专享，升级VIP请联系客服。服务热线:027-87665517转6003。邮箱: userservice@sunther.com',
    stdValid2018: '2018标准有效版本清单',
    stdValid2019: '2019标准有效版本清单',
    stdValid2020: '2020标准有效版本清单',
    stdValid2021: '2021标准有效版本清单',
    stdValid2022: '2022标准有效版本清单',
    stdValid2023: '2023标准有效版本清单',
    stdValid2024: '2024标准有效版本清单',
    intlStd2018: '2018国际工程标准清单',
    intlStd2019: '2019国际工程标准清单',
    intlStd2020: '2020国际工程标准清单',
    intlStd2021: '2021国际工程标准清单',
    intlStd2022: '2022国际工程标准清单',
    intlStd2023: '2023国际工程标准清单',
    intlStd2024: '2024国际工程标准清单',
  },
  header: {
    platformName: '中外工程技术标准数据管理平台',
    message: '消息',
    feedback: '需求反馈',
    zh: 'ZH',
    en: 'EN',
    login: '登录',
    register: '注册',
    hello: '您好',
    settings: '资料设置',
    myCollection: '我的收藏',
    myOrder: '我的订单',
    orderManage: '订单管理',
    logout: '退出登录',
  },
  home: {
    viewMore: '查看更多',
    searchPlaceholder: '请输入内容',
    searchBtn: '搜索',
    searchEmptyTips: '请输入搜索内容',
    searchSynthesis: '综合搜索',
    searchComparison: '标准比对',
    searchId: '标准编号',
    searchName: '标准名称',
    searchContent: '条款内容',
    techKeywords: '相关技术关键词推荐',
    crossKeywords: '跨语言关键词推荐',
    designTitle: '中国电力设计标准与国际标准和国外标准比较研究',
    designSubheading: '《中国电力设计标准与国际标准和外国标准比较研究》是第一部结合“中国电力标准国际化工程”完成的大型专业、系列丛书。丛书共27卷，按照专业分别为电力工程勘测、火力发电工程、输变电工程、新能源工程等四部分。',
    designDialogTitle: '《中国电力设计标准与国际标准和国外标准比较研究》系列丛书',
    designDialogP1: '由中国电力规划设计协会主导，11家设计院单位牵头，14家设计院单位参与编制。以中国标准为蓝本，将中国现行（截至2013年颁布）电力设计国家（GB）和行业（DL）标准与国际标准化组织IEC、IEEE、 ISO、欧盟、世界银行等，以及美国等11个国家标准分标准、分专业、分模块进行对比，对其中的安全、环保、主要参数和技术要求等重要条款做出评价（如宽严程度、差异原因等），提出使用指南。',
    designDialogP2: '2010年12月，中国电力规划设计协会提出了《中国电力设计标准与国际标准和国外先进标准比较研究》项目建议书，并组织专家讨论通过了该项目建议书。2015年6月，完成27卷52分册的编写工作，按照专业分别为电力工程勘测、火力发电工程、输变电工程、新能源工程等四部分。《中国电力设计标准与国际标准和国外标准比较研究》的面世对推动中国电力设计标准国际化，打破中外技术交流屏障具有深远意义。',
    constructionTitle: '中国电力施工部分标准与国际标准和国外标准比较研究',
    constructionSubheading: '国际工程火电/输变电建设技术标准应用研究课题针对土建、锅炉、汽机、电气、热控、焊接、调试和输变电八个专业进行中外建设技术标准的研究。',
    constructionDialogTitle: '《中国电力设计标准与国际标准和国外标准比较研究》系列丛书',
    constructionDialogP1: '“国际工程火电/输变电建设技术标准应用研究课题”针对土建、锅炉、汽机、电气、热控、焊接、调试和输变电八个专业进行中外建设技术标准的研究，具体包括中外技术标准体系的研究、中外重要技术标准的翻译、中外技术标准的比较、国际工程中外标准比较应用案例研究、开发国际工程技术标准应用研究课题工作站，并开展相关培训活动。本课题的研究成果将用于指导企业快速掌握国际标准尤其是先进的国际技术标准、了解中外技术标准差异与关联，提升企业国际竞争力。通过对比、采用先进标准，有利于为客户提供高品质的产品和服务，增强市场信赖程度，从而拓展国际市场，在竞争中处于优势地位。',
    publicationTitle: '中国标准英文版出版物',
    tradeTitle: '国别技术法规',
    groupTitle: '中国电力规划设计协会团体标准（CEPPEA标准）',
    groupSubheading: '为推动行业技术创新和管理标准化，中国电力规划设计协会响应国家大政方针， 2017年开始开展团体标准（CEPPEA标准）工作，建立了相关管理制度、标准体系、管理机构，并逐步开展了标准编制。CEPPEA标准以满足市场和创新需要为目标，关注工程总承包全过程，聚焦新技术、新产业、新业态和新模式，现阶段工作重点是填补标准空白和提升标准竞争力。',
    mapTitle: '世界标准地图',
    announcementTitle: '平台公告',
    renewalTitle: '最近更新标准',
    currentStatus: '现行',
    publishedCeppea: '已发布CEPPEA标准',
    solicitCeppea: 'CEPPEA标准征求意见',
    publishedTips: '为更好的服务于会员单位，中国电力规划设计协会现全文公开已经发布的团体标准。',
    solicitTips1: 'CEPPEA标准征求意见稿起草完成后，协会组织向涉及本标准内容的利益相关方以信函方式征求意见。',
    solicitTips2: '征求意见一般不少于30日。被征求意见的单位或个人应当在规定日期前回复意见，对所有意见，应当说明依据或理由；逾期不回复的，视为无异议。',
    mapCountry: '国家',
    mapIso: '国际标准化组织',
    mapCollectLabel: '信息收集完成度:',
    mapHigh: '高',
    mapMedium: '中',
    mapLegendMedium: '信息收集完成度-中',
    mapLegendHigh: '信息收集完成度-高',
  },
  common: {
    collapse: '收起',
    expand: '展开',
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    loginSuccess: '登录成功',
    logoutSuccess: '退出成功',
    notLoggedIn: '未登录，请登录',
    rolesSyncFail: '权限同步失败!',
    copySuccess: '复制成功',
    networkError: '网络错误',
    noPermission: '无权限,请联系管理员userservice@sunther.com',
    noPermissionExclaim: '无权限,请联系管理员userservice@sunther.com!',
    sessionExpired: '登录状态过期,请重新登录！',
  },
  footer: {
    intro: '始于1995年，双泽（SUNTHER）公司是企业国际化、信息化、标准化三化合一国际市场综合解决方案服务商。双泽依靠技术进步和先进思想为客户创造价值，汇聚了具有丰富国际市场经验的技术、商务及管理专业人士，自主研发了跨语言／国别技术及市场信息大数据挖掘（关联）技术。',
    officialSite: '公司官网',
    hotline: '服务热线',
    serviceEmail: '客服邮箱',
    followUs: '关注我们',
    copyright: 'Copyright © 1995-2026 - 中外电力工程技术标准数据管理平台 鲁ICP备11005380号-1 版权所有 © 北京双泽维度信息技术有限公司',
  },
  standard: {
    footerCopyright: 'Copyright © 1995-2026 - 中外电力工程技术标准数据管理平台 鲁ICP备11005380号-1 版权所有 © 北京双泽维度信息技术有限公司',
    statusCheck: '标准状态检查',
    reset: '重置',
    startStopNotice: '启用,停用标准通知',
    startStopTitle: '启用停用标准通知',
    menuKeywordPlaceholder: '请输入标准关键词',
    menuSearch: '搜索',
    menuPrev: '上一条',
    menuNext: '下一条',
    blurTitle: '模糊检索',
    blurEmptyMatch: '请输入关键词匹配',
    blurCollapseFilter: '收起筛选',
    blurExpandFilter: '展开筛选',
    blurKeywordLabel: '检索关键词',
    statusTitle: '标准状态检查',
    statusDesc: '《标准状态检查》功能可以按照标准编号批量检测标准状态详情，并给出当前标准状态及最新版本标准。',
    statusNote: '注：请先下载下方的excel模板，按照提示填写后上传',
    statusDownloadTemplate: '下载模板',
    statusSubmit: '表格提交',
    statusDownloadResult: '下载结果',
    statusFileTypeError: '文件类型错误',
    statusFileUploaded: '该文件已上传',
    precisionTitle: '精准检索',
    precisionSearch: '搜索',
    precisionReset: '重置',
    unlimited: '不限',
    noMoreData: '已经没有数据了',
    stdName: '标准名称',
    stdNamePlaceholder: '请输入标准名称',
    stdNo: '标准编号',
    stdNoPlaceholder: '请输入标准编号',
    language: '语种',
    languagePlaceholder: '请选择语种',
    yearNumber: '年代号',
    yearPlaceholder: '请选择年代号',
    to: '至',
    ics: 'ICS分类',
    icsPlaceholder: '请输入ICS分类',
    viewIcs: '查看ICS分类',
    icsDialogTitle: 'ICS分类',
    ccs: 'CCS分类',
    ccsPlaceholder: '请输入CCS编号',
    viewCcs: '查看CCS分类',
    ccsDialogTitle: 'CCS分类',
    resource: '标准来源',
    resourcePlaceholder: '请选择标准来源',
    status: '标准状态',
    statusPlaceholder: '请选择标准状态',
    materialDate: '实施日期',
    releaseDate: '发布日期',
    draftUnit: '起草单位',
    draftUnitPlaceholder: '请输入起草单位',
    drafter: '起草人',
    drafterPlaceholder: '请输入起草人',
    batchTip: '可通过多条件精确筛选后下载!',
    bulkExport: '批量导出',
    confirm: '确定',
    cancel: '取消',
    exportDisclaimer: '本网站转载文字,图片等稿件均出于为公众传播有益资讯信息并且不以盈利为目的,转载稿件不意味着赞同其观点或证实其内容的真实性，本网不对其科学性，严肃性等作任何形式的保证。如其他媒体，网络或个人从本网下载使用需自负版权等法律责任。',
    selectFileFirst: '请选择文件!',
    fileTitleModal: '导出文件标题',
    fileTitleLabel: '文件标题',
    fileTitlePlaceholder: '请输入文件标题',
    fileTitleRequired: '请输入文件标题',
    downloading: '正在下载,请稍等!',
    orientation: '体系定位',
    orientationTip: '点击体系定位图标,可直接并且还能在左方体系树查看标准体系所在的位置。',
    orientationFail: '体系定位失败!',
    colIndex: '编号',
    colStdNo: '标准编号',
    colStdName: '标准名称',
    colLanguage: '语种',
    colStatus: '状态',
    colAction: '操作',
    uncollectSuccess: '删除成功!',
    collectSuccess: '收藏成功!',
    uncollectFail: '删除失败!',
    collectFail: '收藏失败!',
    downloadConfirm: '下载文本?',
  },
  standardDetail: {
    stdNameZh: '技术标准名称(中文)：',
    stdNameEn: '技术标准名称(英文)：',
    stdNameOriginal: '技术标准名称 (原文) :',
    stdNameTrans: '技术标准名称 (译文) :',
    basicInfo: '基本信息',
    resourceOrg: '标准来源/发布机构：',
    language: '语 种：',
    ics: 'ICS分类号:',
    hasTranslation: '是否有译文：',
    ccs: 'CCS分类号:',
    industry: '行 业：',
    yearNumber: '年代号：',
    specialty: '专 业：',
    materialDate: '生效日期：',
    enforce: '是否是强标：',
    category: '标准类别：',
    technicalCommittees: '归口单位',
    executionUnit: '执行单位',
    competentDepartment: '主管部门',
    draftUnit: '起草单位',
    drafter: '起草人',
    useScope: '适用范围',
    replaceStd: '代替以下标准',
    stdUse: '被以下标准采用',
    replaceBy: '被以下标准代替',
    project: '涉及的工程项目',
    exportDetail: '导出详情',
    getText: '获取文本',
    viewTrans: '查看译文',
    viewOriginal: '查看原文',
    downloadOriginal: '原文下载',
    downloadText: '文本下载',
    none: '无',
    loading: '加载中...',
    username: '用户名:',
    exportTime: '导出时间:',
    dataFormatError: '数据格式错误,详情查询失败!',
    fileLoadFail: '文件加载失败!',
    createFail: '数据创建失败了,请刷新重试!',
  },
  digitization: {
    surveyDesign: '勘察设计',
    installation: '安装施工',
    categoryFilterPlaceholder: '请选择分类进行筛选',
    keywordPlaceholder: '请输入对标点名称关键字搜索',
    colIndex: '编号',
    colCategory: '分类',
    colName: '对标点名称',
    colAction: '操作',
    viewCompare: '查看对比结果',
  },
  standardComparison: {
    searchPlaceholder: '请输入标准比对关键词查询',
    compareList: '比对列表',
    pointList: '对标点列表',
    compareResult: '比对结果',
    pointLabel: '对标点：',
    domesticStd: '国内标准：',
    foreignStd: '国外标准：',
    checkTip: '请勾选左侧对标点查看对比结果',
    trans: '译',
    original: '原',
    onlyTransTip: '此处仅提供译文,如需参考原文请提交您的需求',
    onlyOriginalTip: '此处仅提供原文,如需参考译文请提交您的需求',
  },
  benchmarking: {
    fullTextSearch: '全文检索',
    titleSearch: '标题检索',
    advancedSearch: '高级检索',
    specialty: '专业卷册',
    specialtyPlaceholder: '请选择专业卷册',
    deepSpecialty: '细分专业卷册',
    deepSpecialtyPlaceholder: '请选择细分专业卷册',
    contentType: '内容分类',
    contentTypePlaceholder: '请选择内容分类',
    countryType: '国别分类',
    countryTypePlaceholder: '请选择国别分类',
    overview: '概述',
    compareStandards: '参与比较的中外标准',
    mainCompare: '主要比较内容',
    compareNote: '比较说明',
    projectSummary: '项目总结',
    chinaPrefix: '中国',
    noData: '暂无数据',
    collapseMore: '收起更多',
    networkError: '设备网络错误',
  },
  benchmarkingDetail: {
    indexCatalog: '索引/目录',
    exportPage: '导出页面',
    keywordPlaceholder: '请输入关键词',
    searchResult: '搜索结果',
    pageMatchPrefix: '当前页共 ',
    pageMatchSuffix: ' 条数据',
    exportPreview: '导出预览',
    articleLoading: '文章加载未完成,请稍后!',
    exportComplete: '导出完成',
    maxKeywords: '最多只能三条关键字!',
    menuIdEmpty: '菜单id为空!',
  },
  standardTranslation: {
    subtitle: '由CEPPEA授权的中国电力行业规范和标准英文版出版物的推广',
    standardElement: '标准化要素',
    relatedStandard: '相关标准',
  },
  technicalRegulations: {
    lawsSearchPlaceholder: '法律法规检索',
    updatedLaws: '更新的法律法规',
    recentlyUpdated: '最近更新',
    allCountries: '全部国家',
    bilingualReading: '双语阅读',
    translationReading: '译文阅读',
    originalReading: '原文阅读',
  },
  industryInformationBase: {
    downloadReport: '下载报告',
    downloadOriginal: '下载原文',
    downloadTrans: '下载译文',
    original: '原文',
    translation: '译文',
    currentPage: '当前页',
    nationalInfoBase: '国家产业信息库',
    lawsRegulations: '国别法律法规',
    standardTrade: '中外标准应用',
    transfer: '国际技术转移',
    userInfoBase: '用户信息库',
    idNotExist: 'id不存在!',
    keyNotExist: '关键key不存在!',
    keywordSearchPlaceholder: '请输入关键词,在文件内进行检索',
  },
  languageService: {
    submitOrder: '提交订单',
    orderConfirmTitle: '请确认机器翻译订单信息',
    knowledgeTitle: '翻译需知',
    knowledgeMachineTip: '为了保证翻译效果，建议所翻译的文档符合一下要求：',
    knowledgeHumanTip: '人工翻译有专业级，出版物级和SCI论文翻译（电气领域）三种不同翻译质量的服务，选择服务不同价格不同，具体价格会有我们人工翻译的工作人员联系沟通。',
    knowledgeLangMachine: '翻译语种：中文，英文的互译',
    knowledgeSpecialty: '专业方向：科学，技术，工程，数学及工业领域',
    knowledgeFormat: '文档格式：doc，docx，xls，xlsx，ppt，pptx，清晰的可编辑的pdf。',
    knowledgeHumanTypes: '目前人工翻译服务所支持的文档类型有：',
    knowledgeLangHuman: '翻译语种：英，法，日，韩，德，俄，西，葡，印尼语，波斯语',
    wechatPay: '微信支付',
    alipayPay: '支付宝支付',
    transType: '翻译类型',
    transTypeRequired: '请选择翻译类型',
    instructionsHuman: '说明：快速机器翻译+行业专家逐句校核；适用于各专业技术文件、商务文件翻译；免费排版、完全对应原文格式',
    instructionsMachine: '说明：快速机器翻译，适用于数量大且急需参考译文的文件',
    languageDirection: '语言方向',
    uploadFile: '上传文件',
    fileUploadFail: '文件上传失败',
    orderSubmitFail: '订单提交失败，请检查上传文件或联系客服',
    fileDeleteSuccess: '文件删除成功',
    uploadDragTip: '点击或将文件拖拽到这里上传',
    uploadSupportTip: '支持doc,docx,xls,xlsx,ppt,pptx,清晰的可复制的pdf',
    contactName: '联系人',
    contactNamePlaceholder: '请输入联系人',
    contactNameRequired: '请输入联系人',
    mobilePhone: '联系电话',
    mobilePhonePlaceholder: '请输入联系电话',
    mobilePhoneRequired: '请输入联系电话',
    remark: '需求备注',
    remarkPlaceholder: '请输入需求备注',
    deliveryTime: '交付时间',
    deliveryTimeDesc1: '译文交付时间视文件量而定。一般情况下，工作时间内的订单当日或次日交付译文;',
    deliveryTimeDesc2: '如需加急服务，请咨询0531-88897205；徐经理:18627076118。',
    uploadFileRequired: '请上传文件',
    selectPayMethod: '选择支付方式：',
    confirmAndPay: '确认并支付',
    confirmTranslate: '确认翻译',
    cancel: '取 消',
    textNum: '翻译字符数统计',
    textNumPlaceholder: '请输入翻译字符数统计',
    priceMultipleMt: '语言价格(元/千中文字)',
    priceMultipleMtPlaceholder: '请输入语言价格(元/千中文字)',
    freeWordsUsed: '使用免费字符数',
    freeWordsUsedPlaceholder: '请输入使用免费字符数',
    wordCount: '计费字数(字)',
    wordCountPlaceholder: '请输入计费字数(字)',
    originalPrice: '订单总价(元)',
    originalPricePlaceholder: '请输入订单总价',
    discountedPrice: '折扣',
    discountedPricePlaceholder: '请输入折扣',
    exceededWordCount: '实付金额(元)',
    exceededWordCountPlaceholder: '请输入实付金额(元)',
  },
  informationNavigation: {
    dataSourceNav: '数据源导航',
    pleaseLogin: '请登录!',
  },
  standardList: {
    headerDesc: '《国际工程标准清单》由中国电力规划设计协会为主导，各省级院及以上会员单位协助汇编项目及标准信息，双泽进行整理的清单。本《清单》收录了从2016年截止至今的219个工程项目的技术标准清单，工程分布在61个国家和地区的184个省/地区，涉及火力发电、水力发电、新能源发电、输变电、储能、综合能源、咨询和其他领域。',
    projectTitle: '国际工程项目清单',
    exportList: '清单导出',
    selectExportData: '请选择导出数据',
    exportFileNameProject: '国际电力工程标准清单_项目',
    colIndex: '序号',
    colProjectName: '项目名称',
    colProjectType: '项目类别',
    colProjectDesc: '项目描述',
    colProjectRegion: '项目地区',
    colStdCount: '标准数量',
    viewList: '查看清单',
    projectTypePlaceholder: '请选择项目类别',
    region: '所在地区',
    regionPlaceholder: '请选择所在地区',
    all: '全部',
    exportFileNameStd: '国际电力工程标准清单_标准',
    invalidData: '错误的数据!',
    powerListTitle: '国际电力工程标准清单',
    viewDetail: '查看详情',
  },
  message: {
    title: '消息中心',
    systemMessage: '系统消息',
    notice: '公告通知',
  },
  feedback: {
    title: '需求反馈',
    putForward: '提出需求',
    selectType: '请选择需求类型！',
    welcomeUser: '尊敬的用户：',
    welcomeBody: '您好！为了能更好地完善PES平台，使其在功能、数据范围、用户友好等方面更好地满足广大工程师的具体工作需要， 我们设计了“需求反馈中心”，让用户能够方便、快捷地提出自己的需求。 请根据您的需求类型，点击左侧链接，填写需求表格并提交，我们会及时与您联系并告知反馈进展。',
    menuTechText: '技术标准文本需求',
    menuOptimize: '功能优化/新增需求',
    menuSystem: '技术标准体系需求',
    menuComparison: '中外技术标准比对需求',
    menuTranslation: '技术标准文本译文需求',
    submitNeed: '提交需求',
    submitSuccess: '您的需求已提交',
    submitFail: '提交失败',
    techTextTips: '如果您有日常工作频繁使用的标准，请在此模块向我们提出！',
    techTextJoin: '如果您知道您关注的标准编号或名称，请在下方的表格中填写：',
    specialty: '专业',
    stdResource: '标准代号/标准来源',
    translationChargeNote: '（注：标准译文获取为<span class="hl">收费需求</span>，您填完相关需求之后，随后会有相关报价发送至您邮箱，或有相关人士与您联系进行沟通相关报价）',
    optimizeTips: '如果您发现PES站的某些功能需要优化，或者您希望PES站加入新的功能，请在此模块向我们提出!',
    needPlaceholder: '请输入您的需求',
    needRequired: '请输入您的需求',
    systemTips: '如果您有日常工作频繁使用的标准体系，请在此模块向我们提出！',
    systemJoin1: '1. 请填写您希望PES站加入的标准体系：',
    sysShortName: '标准体系简称',
    sysFullName: '标准体系全称',
    sysUrl: '标准体系链接',
    systemJoin2: '2. 如果您不清楚具体标准体系名称或链接，请在下方详细描述您的需求。',
    needDescPlaceholder: '请填入具体需求',
    kbClauseName: '对标点名称',
    kbStdNo: '中文标准编号',
    kbStdName: '中文标准名称',
    kbStdNoEn: '英文标准编号',
    kbStdNameEn: '英文标准名称',
    projectType: '项目类型',
    projectTypePlaceholder: '请选择项目类型',
    projectStage: '项目阶段',
    projectStagePlaceholder: '请选择项目阶段',
    projectCategory: '项目类别',
    projectCategoryPlaceholder: '请选择项目类别',
    projectScale: '项目规模',
    projectScalePlaceholder: '请选择项目规模',
    scopeNum: '机组的台套数',
    scopeSize: '单机容量',
    scopeLevel: '电压等级',
    scopeLength: '线路长度',
    scopeOther: '其他',
    perfectInfoTitle: '完善个人信息',
    perfectInfoTips: '以下信息非常重要，请认真填写，以便我们能及时与您取得联系！',
    perfectInfoBtn: '完善信息',
    confirm: '确定',
    userName: '姓名',
    userNamePlaceholder: '请输入姓名',
    userNameRequired: '请输入姓名',
    email: '电子邮箱',
    emailPlaceholder: '请输入电子邮箱',
    emailRequired: '请输入电子邮箱',
    mobilePhone: '手机号码',
    mobilePhonePlaceholder: '手机格式：13311111111，国际号码：14139621234',
    telephone: '座机号码',
    telephonePlaceholder: '座机格式：010-11111111，0101-1111111，010-11111111-1111',
    company: '工作单位',
    companyPlaceholder: '请输入工作单位',
  },
  individualCenter: {
    vipExpirePrefix: 'VIP有效期至：',
    mtFreeQuota: '机翻免费额度：',
    enterpriseVip: '企业vip',
    enterpriseVipExpired: '企业过期vip',
    notLoggedIn: '用户未登录!',
    networkError: '设备网络错误',
    networkErrorShort: '网络错误',
    changePassword: '修改密码',
    wantEdit: '我要修改',
    cancelEdit: '取消修改',
    confirmUpdate: '确认更新',
    profileUpdateSuccess: '修改资料成功!',
    mobilePlaceholder: '请输入手机号码',
    mobileRequired: '请输入手机号码',
    telephonePlaceholder: '请输入座机号码',
    confirmBtn: '确认',
    oldPassword: '原始密码',
    oldPasswordPlaceholder: '请输入原始密码',
    oldPasswordRequired: '请输入原始密码',
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入新密码',
    newPasswordRequired: '请输入新密码',
    passwordLength: '长度在 8 到 16 个字符',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请输入确认密码',
    confirmPasswordRequired: '请输入确认密码',
    passwordMismatch: '两次密码不一致',
    passwordUpdateSuccess: '修改成功,请重新登录',
    passwordUpdateFail: '修改失败',
    collectTime: '收藏时间',
    warmTip: '温馨提示',
    deleteCollectConfirm: '是否要删除该收藏',
    cancelCollectSuccess: '取消收藏成功！',
    cancelCollectFail: '取消收藏失败功！',
    orderTipsTitle: '温馨提示：',
    orderTip1: '1、本页面的支付状态可能会有滞后。',
    orderTip2: '2、如遇到翻译失败的订单，可联系客服处理：0531-88897205；徐经理：18627076118。',
    machineOrder: '机翻订单',
    humanOrder: '人工翻译订单',
    searchOrderPlaceholder: '请输入文件名称或订单编号搜索',
    orderStatePlaceholder: '请选择订单状态',
    fileName: '文件名称',
    amount: '金额',
    orderState: '订单状态',
    orderTimePrefix: '下单时间：',
    orderNoPrefix: '订单号：',
    viewOrder: '查看订单',
    downloadTrans: '下载译文',
    downloadOriginal: '下载原文',
    payNow: '立即支付',
    cancelOrder: '取消订单',
    contactService: '联系客服',
    serviceNotified: '已通知客服，会在工作日24小时内处理。请保持订单联系号码通畅！',
    charCountTipMachine: '原文件翻译字符数统计，一个汉字计为两个字符，英文字母、标点符号、空格等均计为一个字符。',
    charCountTipHuman: '不论是英译中或是中译英，均以中文计数。Word文件以Word文档字数统计的“字符数（不计空格）”栏计算字数统计。PPT文件和EXCEL文件则将该文件全文复制到Word里后，再按上述方法统计字数。',
    statusPendingPay: '待支付',
    statusOrdered: '已下单',
    statusTranslating: '翻译中',
    statusPendingPickup: '待取件',
    statusPickedUp: '已取件',
    statusCancelled: '已取消',
    statusFailed: '翻译失败',
    unit: '单位',
    user: '用户',
    orderInfo: '订单信息',
    save: '保存',
    close: '关闭',
    orderId: '订单号',
    orderIdPlaceholder: '请输入订单号',
    machineTrans: '机翻',
    languageDirectionRequired: '请选择语言方向',
    languageDirectionPlaceholder: '请输入语言方向',
    username: '用户名',
    usernamePlaceholder: '请输入用户名',
    unitName: '单位名称',
    unitNamePlaceholder: '请输入单位名称',
    totalWordCount: '总字数统计',
    totalWordCountPlaceholder: '请输入总字数统计',
    originalPrice: '订单总价',
    originalPricePlaceholder: '请输入订单总价',
    amountDue: '实付金额',
    amountDuePlaceholder: '请输入实付金额',
    sourceFile: '原文文件',
    transFile: '译文文件',
    uploadOriginal: '上传原文',
    uploadTrans: '上传译文',
    none: '无',
    discountedPriceYuan: '折扣(元)',
    discountedPriceYuanPlaceholder: '请输入折扣(元)',
  },
  orderDetail: {
    title: '订单详情',
    orderInfo: '订单信息',
    fileInfo: '文件信息',
    contactInfo: '联系信息',
    paymentInfo: '支付信息',
    fold: '折',
    payMethod: '支付方式',
    unpaid: '未支付',
    free: '免费',
    tradeTime: '交易时间',
    tradeNo: '交易号',
    orderNoPrefix: '订单号:',
    statusPrefix: '状态：',
    downloadTip: '尊敬的用户,您的文件已翻译完成,请点击下方文件进行译文下载。',
    downloadTransFile: '译文文件下载',
    fileCount: '文件数量',
    transChars: '翻译字符数',
    createTime: '创建时间',
    languageSpecialty: '语言专业',
    noData: '暂无数据',
    sourceFileColon: '原文文件：',
  },
  login: {
    intro: 'PES平台依托跨语言、跨专业的数据关联与过滤技术，基于先进国际工程项目管理内专业逻辑，通过建立全球数据源的合作关系精准定位并获取技术标准以及相关国际电力工程最佳实践等专业技术信息数据，对其进行归纳、关联，并实时动态更新管理，并在国际电力工程项目管理各个环节中，客观呈现相互之间在技术、商务、管理领域中多维度关联关系。',
    title: '登录',
    account: '账号',
    usernamePlaceholder: '输入用户名',
    usernameRequired: '请输入用户名',
    password: '密码',
    passwordPlaceholder: '输入密码',
    passwordRequired: '请输入密码',
    captcha: '验证码',
    captchaRequired: '请输入验证码',
    captchaPlaceholder: '点击验证码可更换验证码',
    forgetPassword: '忘记密码？',
    registerNow: '立即注册',
    registerTitle: '注册',
    hasAccount: '已有账号?',
    loginDirect: '直接登录',
    accountPlaceholder: '输入账号',
    accountRequired: '请输入账号',
    email: '邮箱',
    emailPlaceholder: '输入邮箱',
    emailRequired: '请输入邮箱',
    phone: '手机号',
    phonePlaceholder: '输入手机号',
    phoneRequired: '请输入手机号',
    confirmPasswordPlaceholder: '输入确认密码',
    emailCode: '邮箱验证码',
    codePlaceholder: '输入验证码',
    sendEmailCode: '发送验证码到邮箱',
    accountRegistered: '账号已被注册,请更换!',
    emailRegistered: '邮箱已被注册,请更换!',
    phoneRegistered: '手机号已被注册,请更换!',
    passwordMismatch: '两次密码不一致!',
    usernameAvailable: '用户名可用!',
    emailAvailable: '邮箱可用!',
    phoneAvailable: '手机号可用!',
    usernameLength: '长度在 2 到 30 个字符',
    noSpace: '不允许输入空格等特殊符号',
    emailFormat: '请输入正确格式的邮箱地址',
    phoneFormat: '请输入正确格式的手机号码',
    weakPassword: '至少包含字母、数字、特殊字符,1-9位,并且不能连续出现3个大小连续或相同的数字',
  },
  smartQA: {
    newChat: '新建对话',
    recentChats: '最近对话',
    newSession: '新对话',
    renameSession: '重命名会话',
    deleteSession: '删除会话',
    noHistory: '暂无历史对话',
    welcomeTitle: '标准智能问答助手',
    welcomeSubtitle: '基于中外工程技术标准数据，为您答疑解惑',
    currentBenchmark: '当前对标点：',
    copyContent: '复制内容',
    aiGenerating: 'AI 正在生成…',
    aiThinking: 'AI 正在思考…',
    selectedBenchmarkLabel: '已选择对标点：',
    cancel: '取消',
    inputPlaceholder: '请输入您想咨询的标准问题，例如：GB 50052 的适用范围是什么？',
    promptConfig: '提示词配置',
    inputTips: 'AI 生成内容仅供参考，请以正式标准文本为准',
    refsPanel: '来源引用',
    itemUnit: '条',
    clausePrefix: '第',
    relevance: '相关度',
    closePromptConfig: '关闭提示词配置',
    systemPromptLabel: '系统提示词',
    userPromptTemplateLabel: '用户消息格式',
    varHistory: '近期对话',
    varContext: '检索上下文',
    varQuestion: '用户问题',
    resetDefault: '恢复默认',
    save: '保存',
    renamePlaceholder: '请输入会话标题',
    defaultSystemPrompt: '你是电力工程标准智能问答助手。请用中文回答用户问题。\n回答要求：\n1. 只依据提供的知识库资料回答，禁止编造标准号、条款号或技术要求。\n2. 引用资料时必须在对应结论后使用引用标签，例如 [引用1]，标签必须与提供的 [引用N] 编号一致；同时保留标准编号和条款号。\n3. 当回答对应某个技术对标点时，必须分别汇总中方和外方标准，并覆盖提供的所有不同标准条款；不能只挑选部分标准或条款。\n4. 如果资料不足以回答，请明确说明，并列出最相关的标准条款供用户查阅。\n5. 使用简洁、结构化的中文回答，可包含短段落和列表。',
    legacyCitationReplace: '2. 引用资料时必须在对应结论后使用引用标签，例如 [引用1]，标签必须与提供的 [引用N] 编号一致；同时保留标准编号和条款号。',
    legacyStructureReplace: '3. 当回答对应某个技术对标点时，必须分别汇总中方和外方标准，并覆盖提供的所有不同标准条款；不能只挑选部分标准或条款。\n4. 如果资料不足以回答，请明确说明，并列出最相关的标准条款供用户查阅。\n5. 使用简洁、结构化的中文回答，可包含短段落和列表。',
    serviceUnavailable: '问答服务暂时不可用',
    suggest1: '如何快速查找某条标准的中英文对照？',
    suggest2: '数字化标准比对结果如何解读？',
    suggest3: '请推荐电力工程勘察设计相关标准',
    suggest4: 'GB 50052 与 IEC 60364 的主要差异是什么？',
    suggestBenchmark1Prefix: '请介绍对标点「',
    suggestBenchmark1Suffix: '」关联的主要标准',
    suggestBenchmark2: '该对标点下中外标准要求有哪些差异？',
    suggestBenchmark3Prefix: '请列出  相关的关键技术要求',
    connectFailed: '问答服务连接失败，请确认后端已启动',
    loadSessionFailed: '加载会话失败',
    titleEmpty: '会话标题不能为空',
    titleUpdated: '会话标题已更新',
    renameFailed: '重命名会话失败',
    deleteWhileStreaming: '回答生成中，请稍后再删除会话',
    deleteConfirmPrefix: '确定删除「',
    deleteConfirmSuffix: '」吗？该会话的问答记录将一起删除。',
    deleteOk: '删除',
    deleted: '会话已删除',
    deleteFailed: '删除会话失败',
    createFailed: '新建对话失败',
    selectedBenchmarkSuccessPrefix: '已选择对标点：',
    selectBenchmarkFirst: '请先选择对标点',
    appliedBenchmarkPrefix: '已应用对标点：',
    copied: '已复制到剪贴板',
    copyFailed: '复制失败，请手动选择内容复制',
    systemPromptEmpty: '系统提示词不能为空',
    promptSaved: '提示词配置已保存',
    requestFailedPrefix: '请求失败：',
    serviceUnavailableRetry: '问答服务暂时不可用，请稍后重试',
    noAnswer: '未获取到回答',
    viewCitation: '查看来源引用',
    entryTitle: '标准智能问答',
    entryDesc: '输入标准问题，AI 基于平台数据为您快速解答',
    entryBtn: '立即咨询',
    entryFab: '智能问答',
  },
};
